import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['item', 'answer', 'icon'];
  static values = { index: Number }

  connect() {
    this.activeIndex = null;
  }

  toggle(event) {
    const clickedIndex = Number(event.currentTarget.dataset.indexValue);
  
    this.itemTargets.forEach((el, i) => {
      const answer = this.answerTargets[i];
      const icon = this.iconTargets[i];
      const isActive = clickedIndex === i;
  
      if (isActive && this.activeIndex === i) {
        answer.style.height = answer.scrollHeight + 'px';
        requestAnimationFrame(() => {
          answer.style.height = '0px';
        });
        icon.classList.remove('rotate-90');
        this.activeIndex = null;
      } else if (isActive) {
        answer.classList.remove('hidden');
        answer.style.height = 'auto';
        const height = answer.scrollHeight + 'px';
        answer.style.height = '0px';
        requestAnimationFrame(() => {
          answer.style.height = height;
        });
        icon.classList.add('rotate-90');
        this.activeIndex = i;
      } else {
        answer.style.height = '0px';
        icon.classList.remove('rotate-90');
      }
    });
  }
}
